<!-- ============================= -->
<!--          NAVBAR               -->
<!-- ============================= -->
<nav class="navbar navbar-expand-lg navbar-black navbar-dark">
  <div class="container container-fluid">

    <!-- Angular-controlled toggler -->
    <button class="navbar-toggler" type="button" (click)="toggleNav()">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Angular-controlled collapse -->
    <div 
      class="navbar-collapse"
      [class.collapse]="!isNavOpen"
      [class.show]="isNavOpen"
      id="navbarNavDropdown">

      <ul class="navbar-nav">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="accountDropdown" role="button" data-bs-toggle="dropdown">
            {{ 'Main.navBar.items.myAccount' | translate }}
          </a>
          <ul class="dropdown-menu" aria-labelledby="accountDropdown">
            <li *ngIf="!loggedIn">
              <a class="dropdown-item" [routerLink]="['/login/']" (click)="closeNav()">
                {{ 'Main.navBar.items.login' | translate }}
              </a>
            </li>
            <li *ngIf="!loggedIn">
              <a class="dropdown-item" [routerLink]="['/createAccount/from/', myRepID]" (click)="closeNav()">
                {{ 'Main.navBar.items.createAccount' | translate }}
              </a>
            </li>
            <li *ngIf="loggedIn">
              <a class="dropdown-item" (click)="logOutCust()" (click)="closeNav()">
                {{ 'Main.navBar.items.logout' | translate }}
              </a>
            </li>
          </ul>
        </li>

        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/shop/from/', myRepID]" (click)="closeNav()">
            {{ 'Main.navBar.items.sampleSets' | translate }}
          </a>
        </li>
      </ul>

      <ul class="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center">
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/cart/from/', myRepID]" (click)="closeNav()">
            <i class="fa fa-shopping-cart"></i>
            {{ 'Main.navBar.items.cart' | translate }} ({{ myProdCount }})
          </a>
        </li>
      </ul>

    </div>

    <!-- Language selector outside of mobile collapse -->
    <div class="lang-select d-flex align-items-center">
      <label class="me-2 mb-0 text-white small">
        {{ 'Main.navBar.label.langSelect' | translate }}
      </label>
      <select #langSelect class="form-select form-select-sm" (change)="useLanguage(langSelect.value)">
        <option *ngFor="let language of languages" [value]="language.code" 
          [selected]="language.code === translate.currentLang">
          {{ language.name }}
        </option>
      </select>
    </div>

  </div>
</nav>



<!-- ============================= -->
<!--    ORIGINAL UI   -->
<!-- ============================= -->

<div>
  <div class="aloeBg">
    <div class="wgradfix">

      <!-- LOGO -->
      <div class="cartLogo">
        <a (click)="goToRepSite()" style="cursor: pointer;">
          <img src="https://cdn.lbrionline.net/file/1061/ba40f9dcf8e91f41113884b2137cba3c/"
               height="75px">
        </a>
      </div>

      <!-- REP INFO -->
      <div class="repMeta" *ngIf="rep">

        <img *ngIf="rep.PublicImageUrl != ''"
             class="rep-img"
             src="https://extranet.securefreedom.com/Lbri/Personal/PersonalImages/{{rep.PublicImageUrl}}" />

        <div class="repInfo">

          <div align="center" *ngIf="myCustName">
            <span class="welcome-text">
              <span class="repShoppingWith">
                &nbsp;&nbsp;{{ 'Main.labels.welcome' | translate }}
              </span>
              <span class="customerName" style="font-family:'Roboto Slab', serif;">
                &nbsp;&nbsp;{{ myCustName }}
              </span>
            </span>
          </div>

          <span class="welcome-text">
            <span class="repShoppingWith">
              &nbsp;&nbsp;{{ 'Main.labels.youreshoppingwith' | translate }}
            </span>
            <span class="repMetaName" style="font-family:'Roboto Slab', serif;">
              &nbsp;&nbsp;{{ rep.DisplayName }}
            </span>
          </span>

        </div>

      </div>

    </div>
  </div>

  <!-- Extra menu wrapper (unchanged) -->
  <div class="mainNav container-fluid">
    <div class="container">
      <nav class="navbar navbar-inverse navbar-static-top hide-this" role="navigation">
        <div class="container">
          <div class="navbar-header"></div>
        </div>
      </nav>
    </div>

    <br />

    <!-- Angular router content -->
    <router-outlet></router-outlet>

    <div
  *ngIf="showNewSessionNotice && !isSessionInvalid"
  style="
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 999998;
    max-width: 420px;
    background: #fff8e1;
    border: 1px solid #e0c97f;
    border-radius: 10px;
    padding: 16px 20px;
    box-shadow: 0 6px 18px rgba(0,0,0,0.12);
  "
>
  <div style="font-weight: 700; margin-bottom: 8px;">
    New session started
  </div>

  <div style="margin-bottom: 12px;">
    Your previous shopping session was invalidated. Continue in this tab.
  </div>

  <button type="button" (click)="dismissNewSessionNotice()">OK</button>
</div>

<div
  *ngIf="isSessionInvalid"
  style="
    position: fixed;
    inset: 0;
    z-index: 999999;
    background: rgba(255,255,255,0.98);
    
    display: flex;
    align-items: center;
    justify-content: center;
  "
>
  <div
    style="
      max-width: 560px;
      padding: 32px;
      text-align: center;
      border: 1px solid #ccc;
      border-radius: 12px;
      background: white;
      box-shadow: 0 6px 24px rgba(0,0,0,0.15);
    "
  >
    <div style="font-size: 48px; line-height: 1; margin-bottom: 12px; color: red;">⚠</div>

    <h2 style="margin-top: 0;">Session replaced</h2>

    <p style="margin-bottom: 0;">
      You started a new order in another tab.<br /><br />
      This session is no longer valid.<br /><br />
      Please close this tab manually.
    </p>
  </div>
</div>
  </div>
</div>
